import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Link,
  Typography,
} from "@mui/material";
import { fillRouteWithSlugs } from "@utils";
import { Link as RouterLink } from "react-router-dom";
import { TaskContent } from "src/components/Roadmap/Task/TaskContent";
import { ROUTE_SLUGS } from "src/config/navigation/routes";
import { RoadmapCard, ROUTES } from "../../config";
import { TaskModalErrorBoundary } from "../ErrorBoundary";

type Props = {
  cardConfig: { card: RoadmapCard; stageKey: string };
  open: boolean;
  handleCloseCardDialog: () => void;
};

export const TaskModal = (props: Props) => {
  const {
    cardConfig: { card: selectedCard },
    open,
    handleCloseCardDialog,
  } = props;

  return (
    <Dialog open={open} onClose={handleCloseCardDialog}>
      <TaskModalErrorBoundary
        card={selectedCard}
        cardKey={selectedCard.cardKey}
        open={open}
        cardTitle={selectedCard.title}
        props={props}
      >
        <DialogTitle>{selectedCard.title}</DialogTitle>
        <DialogContent className="flex flex-col items-start gap-y-4">
          <div className="flex w-full flex-1 flex-col">
            <Typography variant="body1" className="mb-2 font-bold">
              Tasks
            </Typography>
            <div className="flex flex-col gap-y-2">
              <TaskContent {...props} />
            </div>
          </div>
          <Divider className="w-full" />
          <div>
            <Typography variant="body1" className="mb-2 font-bold">
              Description
            </Typography>
            {selectedCard.description && (
              <div className="whitespace-pre-wrap">
                {selectedCard.description}
              </div>
            )}
          </div>
          {selectedCard.helpCenterArticleId && (
            <Link
              component={RouterLink}
              underline="hover"
              to={fillRouteWithSlugs(ROUTES.HELP_CENTER_ARTICLE, {
                [ROUTE_SLUGS.ARTICLE_ID]: selectedCard.helpCenterArticleId,
              })}
            >
              Need more help? Read the detailed guide in the help center
            </Link>
          )}
        </DialogContent>
      </TaskModalErrorBoundary>
      <DialogActions className="flex justify-between">
        <Button onClick={handleCloseCardDialog}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
